import { render, staticRenderFns } from "./FullPageLoad.vue?vue&type=template&id=d5984450&scoped=true"
import script from "./FullPageLoad.vue?vue&type=script&lang=js"
export * from "./FullPageLoad.vue?vue&type=script&lang=js"
import style0 from "./FullPageLoad.vue?vue&type=style&index=0&id=d5984450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5984450",
  null
  
)

export default component.exports